import { alertController, loadingController } from '@ionic/vue';

const UPDATE_LOADING_MESSAGE = 'Update App ...';
const UPDATE_COMPLETE_HEADER = 'Update abgeschlossen';
const UPDATE_COMPLETE_MESSAGE = 'Wir entwickeln unsere Erlebnisse für Dich stetig weiter.';
const UPDATE_COMPLETE_BUTTON = 'Danke';

export async function presentAppUpdateLoading() {
  const loading = await loadingController.create({
    message: UPDATE_LOADING_MESSAGE,
    spinner: 'lines',
    cssClass: 'ollaa-loading',
    duration: 15000,
  });
  await loading.present();
  return loading;
}

export async function presentAppUpdateCompleteAlert() {
  const alert = await alertController.create({
    header: UPDATE_COMPLETE_HEADER,
    message: UPDATE_COMPLETE_MESSAGE,
    cssClass: 'ollaa-alert',
    buttons: [UPDATE_COMPLETE_BUTTON],
  });
  await alert.present();
  await alert.onDidDismiss();
}
